export default __webpack_public_path__ + "static/media/ladders.1f42f93c.png";